import React from "react";
import { useQuery } from "@apollo/client";
import Select from "react-select";
import { CustomDropdownIndicator } from "../../../Settlement/Settlement";
import { GET_ACTIVE_VENDORS_BASIC } from "../../../../../Qurries";

type Props = {
  setVendorId: (id: string) => void;
  setVendorName?: (name: string) => void;
};

function VendorDropdown({ setVendorId, setVendorName }: Props) {
  const { data, loading } = useQuery(GET_ACTIVE_VENDORS_BASIC);

  const vendorOptions =
    data?.getActiveVendorsBasic?.map((vendor: any) => ({
      label: vendor.name,
      value: vendor.vendor_id, 
      id: vendor._id,
      email: vendor.email,
      phone: vendor.phone,
    })) || [];

  return (
    <div className="flex flex-col w-full">
      <Select
        isLoading={loading}
        className="font-normal m-0 capitalize"
        options={vendorOptions}
        components={{
          DropdownIndicator: CustomDropdownIndicator,
          IndicatorSeparator: () => null,
        }}
        onChange={(e: any) => {
          setVendorId(e.value); // vendor_id (used in split_payment_details)
          setVendorName?.(e.label);
        }}
        placeholder={
          <div className="text-[#1E1B59] text-xs">Select Vendor</div>
        }
        styles={{
          control: (provided: any) => ({
            ...provided,
            backgroundColor: "#F6F8FA",
            border: "1px solid #1B163B",
            borderRadius: "6px",
            minHeight: "36px",
          }),
          valueContainer: (provided: any) => ({
            ...provided,
            paddingLeft: "0.5rem",
          }),
          menuList: (provided: any) => ({
            ...provided,
            maxHeight: "200px",
          }),
        }}
      />
    </div>
  );
}

export default VendorDropdown;
